<template>
  <nav>
    <div class="logo" @click="navigateTo('/')">
      <img src="@/assets/images/logos/logo.png" alt="KPP Logo" />
    </div>
    <ul>
      <li><a @click.prevent="navigateTo('/')" :class="{ active: isActive('/') }">首页</a></li>
      <li><a @click.prevent="navigateTo('/about')" :class="{ active: isActive('/about') }">关于我们</a></li>
      <li><a @click.prevent="navigateTo('/products')" :class="{ active: isActive('/products') }">产品展示</a></li>
      <li><a @click.prevent="navigateTo('/ai-chat')" :class="{ active: isActive('/ai-chat') }">AI助手</a></li>
      <li><a @click.prevent="navigateTo('/contact')" :class="{ active: isActive('/contact') }">联系我们</a></li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'NavBar',
  data() {
    return {
      navigationInProgress: false
    }
  },
  methods: {
    navigateTo(path) {
      console.log('[NavBar] 导航到路径:', path);
      
      // 如果已经在当前路径，不执行操作
      if (this.$route.path === path) {
        console.log('[NavBar] 已经在当前路径，不执行导航');
        return;
      }
      
      // 如果有导航正在进行中，防止重复点击
      if (this.navigationInProgress) {
        console.log('[NavBar] 导航正在进行中，忽略此次点击');
        return;
      }
      
      // 设置导航进行中的标记
      this.navigationInProgress = true;
      console.log('[NavBar] 开始导航流程');
      
      // 使用编程式导航
      this.$router.push(path).then(() => {
        console.log('[NavBar] 导航成功完成到:', path);
        
        // 短暂延迟后重置标记
        setTimeout(() => {
          this.navigationInProgress = false;
          console.log('[NavBar] 导航锁定已释放');
        }, 300);
      }).catch(err => {
        console.error('[NavBar] 导航出错:', err);
        this.navigationInProgress = false;
      });
    },
    isActive(path) {
      const isCurrentPath = this.$route.path === path;
      console.log(`[NavBar] 检查路径 ${path} 是否激活: ${isCurrentPath}`);
      return isCurrentPath;
    }
  },
  mounted() {
    console.log('[NavBar] 导航栏组件已挂载');
    console.log('[NavBar] 当前路由:', this.$route.path);
  }
}
</script>

<style scoped>
nav {
  display: flex;
  justify-content: space-between;
  align-items: center; /* 垂直居中，让 logo 和导航文字在同一水平线 */
  background-color: rgba(0, 0, 0, 0.9);
  padding: 8px 40px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  overflow: visible; /* 允许 logo 超出导航栏 */
  height: 56px; /* 固定导航栏高度（8px + 40px + 8px），保持之前的尺寸 */
  box-sizing: border-box; /* 确保 padding 包含在高度内 */
}

.logo {
  cursor: pointer;
  transition: transform 0.2s;
  display: flex;
  align-items: center; /* 与导航文字对齐 */
  height: 140px; /* logo 高度 140px */
  margin-top: 15px; /* 增加顶部空间，让 logo 下移 */
}

.logo img {
  height: 140px; /* logo 尺寸 140px */
  width: auto;
  filter: brightness(0) invert(1); /* 将图片转为白色（如果需要全白） */
  transition: transform 0.2s;
}

.logo:hover {
  transform: scale(1.05);
}

nav ul {
  display: flex;
  list-style-type: none;
  margin: 0;
  padding: 0;
}

nav ul li {
  margin-right: 20px;
}

nav ul li a {
  color: white;
  text-decoration: none;
  font-size: 16px;
  padding: 10px;
  cursor: pointer;
  position: relative;
  transition: color 0.3s;
}

nav ul li a:hover {
  color: #e50914;
}

nav ul li a::after {
  content: '';
  position: absolute;
  width: 0;
  height: 2px;
  bottom: 0;
  left: 50%;
  background: #e50914;
  transition: all 0.3s;
}

nav ul li a:hover::after {
  width: 100%;
  left: 0;
}

.active {
  color: #e50914 !important;
  font-weight: bold;
}

.active::after {
  content: '';
  position: absolute;
  width: 100%;
  height: 2px;
  bottom: 0;
  left: 0;
  background: #e50914;
}
</style> 